module.exports = __webpack_public_path__ + "img/图层22@3x.845fc428.png";